export default __webpack_public_path__ + "static/Fullday-6ef9ec928cd5948fb2f34a83bbda88dd.png";